// Build id of the running bundle vs the one the server currently serves.

// public/uuid.json ships this placeholder; the build overwrites it (see
// vite.config.ts). The dev server builds nothing, so it serves the placeholder.
export const PLACEHOLDER_VERSION = 'UUID'

export function runningVersion(): string {
  return document.getElementById('x-uuid')?.getAttribute('data-version') ?? ''
}

// Static file on this host, not the API, so it bypasses apiClient.
export async function fetchDeployedVersion(): Promise<string> {
  const res = await fetch('/uuid.json', { cache: 'no-store' })
  if (!res.ok) throw new Error(`uuid.json: ${res.status}`)
  const body: unknown = await res.json()
  const version = (body as { version?: unknown } | null)?.version
  return typeof version === 'string' ? version : ''
}

export function reloadPage(): void {
  window.location.reload()
}
